import { useCallback } from 'react';
/**
 * A custom hook to merge multiple refs into a single callback ref.
 * @param refs - An array of refs to be merged.
 * @returns A memoized callback ref.
 */
export function useMergeRefs(refs) {
    return useCallback((node) => {
        // Iterate over the refs and assign the node to each one
        for (const ref of refs) {
            if (!ref) {
                continue;
            }
            if (typeof ref === 'function') {
                // If it's a callback ref, call it with the node.
                ref(node);
            }
            else {
                ref.current = node;
            }
        }
    }, refs);
}
